import React from "react";
import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Tooltip,
  Legend,
} from "chart.js";
import ChartDataLabels from "chartjs-plugin-datalabels";

// Register all necessary Chart.js components and plugins
ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Tooltip,
  Legend,
  ChartDataLabels
);

const SsoStackedBarchart = ({ data }) => {
  // console.log("data", data);

  const chartData = {
    labels: data?.map((item) => item.key),
    datasets: [
      {
        label: "CONF",
        data: data?.map((item) => item.CONF_PERCENT),
        backgroundColor: "#3dc293",
        stack: "stack1",
        barPercentage: 0.7,
        categoryPercentage: 0.7,
      },
      {
        label: "NC",
        data: data?.map((item) => item.NC_PERCENT),
        backgroundColor: "#fd756a",
        stack: "stack1",
        barPercentage: 0.7,
        categoryPercentage: 0.7,
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    indexAxis: "x",
    scales: {
      x: {
        stacked: true,
        ticks: {
          autoSkip: false,
          font: {
            weight: "bold",
          },
        },
        grid: {
          display: false,
        },
      },
      y: {
        stacked: true,
        display: false,
        min: 0,
        max: 100,
        title: {
          display: true,
          text: "Percentage (%)",
        },
        grid: {
          display: false,
        },
      },
    },
    plugins: {
      legend: {
        position: "top",
      },
      tooltip: {
        mode: "index",
        intersect: false,
      },
      datalabels: {
        color: "#000",
        font: {
          weight: "bold",
          style: "italic",
        },
        formatter: (value) => (value === 0 ? "" : `${value}%`),
      },
    },
  };

  return (
    <div style={{ overflowX: "auto", width: "100%" }}>
      <div style={{ minWidth: data?.length * 80, height: "300px" }}>
        <Bar data={chartData} options={options} plugins={[ChartDataLabels]} />
      </div>
    </div>
  );
};

export default SsoStackedBarchart;
